import { type Category } from '@prisma/client'
import { Link } from '@remix-run/react'
import { getImgSrc } from '#app/shared/lib/misc.js'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.js'
import ChevronRightButton from '#app/shared/ui/utils/ChevronRightButton.js'
import { PopularCategoriesCarousel } from './PopularCategoriesCarousel'

type categoryProps = {
  categories: (Category & { image?: { id: string } })[]
}

export default function PopularCategories({ categories }: categoryProps) {
  const slides = categories.map((category) => (
    <Link
      key={category.id}
      to={`/nuestros-coches?carroceria=${category.name}`}
      className={`
        group flex h-40 w-42 ml-4 flex-col items-center justify-center gap-8
        rounded-lg border border-neutral-75 bg-white

        hover:cursor-pointer

        sm:ml-0
      `}
    >
      {category.image?.id ? (
        <div className="relative h-14 w-24">
          <img
            src={getImgSrc(category.image.id, 'categoryImage')}
            alt={category.name}
            className={`
              h-full w-full object-contain transition-opacity duration-100

              group-hover:opacity-70
            `}
            loading="lazy"
          />
        </div>
      ) : (
        <span>No image available</span>
      )}
      <p className="text-base font-bold text-neutral-900">{category.name}</p>
    </Link>
  ))

  return (
    <MainContainer>
      <Spacer
        size="32px"
        className={`
          block

          md:hidden
        `}
      />
      <div className="flex items-center justify-between">
        <p
          className={`
            text-h5-bold font-bold leading-5 text-neutral-900

            lg:text-h3
          `}
        >
          Encuentra tu coche óptimo.
        </p>
        <ChevronRightButton />
      </div>

      <Spacer size="20px" />
      <div
        className={`
          -mx-4

          sm:mx-0
        `}
      >
        <PopularCategoriesCarousel slides={slides} />
      </div>
    </MainContainer>
  )
}
